
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { Truck } from './truck.model';

@Injectable({
  providedIn: 'root'
})
export class TruckOverviewService {

  constructor(private http: HttpService) { }

  public getTrucks(): Observable<Truck[]> {
    const url = `${environment.transportOverviewEndpoint}/trucks`;
    return this.http.postWithContext<Truck[]>(url, {});
  }
}
